import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const testimonials = [
    {
        name: 'Aminat Animashaun',
        role: 'Cloud Architect',
        image: '/img/persons/aminat.jpg',
        linkedin: 'https://www.linkedin.com/in/aminat-animashaun/',
        text: "The CSN training program has equipped me with the knowledge, skills and passion to excel in cloud engineering. I'm excited to continue building a rewarding career in this field.",
    },
    {
        name: 'Gabriel Ayetor',
        role: 'DevSecOps Engineer',
        image: '/img/persons/gabriel.png',
        linkedin: 'https://www.linkedin.com/in/seyramgabriel/',
        text: "Being a part of this community is one of the best things to happen to me this year. I learnt a lot as a DevSecOps trainee, from securing CICD pipelines to container security.",
    },
    {
        name: 'Timilehin Keyede',
        role: 'Security Operations Analyst',
        image: '/img/persons/timilehin.jpg',
        linkedin: 'https://www.linkedin.com/in/oluwatimilehin-keyede-b2034415a/',
        text: "As someone with a keen interest in cloud technology, my recent training at CSN was a game-changer. The practical, hands-on approach made learning a breeze."
    },
];

export default function Testimonials() {
    return (
        <Box
            id="testimonials"
            sx={{
                width: '100%',
                background: 'linear-gradient(180deg, #1a1a1a, #1f1f1f)',
                py: 6,
                color: 'white',
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: '32px',
                        textAlign: 'center',
                        fontWeight: '600',
                        mb: 4,
                    }}
                >
                    Hear from Our Community
                </Typography>
                <Grid container spacing={4}>
                    {testimonials.map((testimonial, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box
                                sx={{
                                    backgroundColor: '#333',
                                    borderRadius: 2,
                                    p: 3,
                                    textAlign: 'center',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Link
                                    href={testimonial.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ textDecoration: 'none' }}
                                >
                                    <Avatar
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        sx={{
                                            width: 56,
                                            height: 56,
                                            mb: 1,
                                        }}
                                    />
                                </Link>
                                <Typography
                                    component={Link}
                                    href={testimonial.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#1e88e5',
                                        textDecoration: 'none',
                                        '&:hover': { textDecoration: 'underline' },
                                        display: 'flex',
                                        alignItems: 'center',
                                        py: 1
                                    }}
                                >
                                    {testimonial.name}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ color: 'rgba(255, 255, 255, 0.75)' }}
                                >
                                    {testimonial.role}
                                </Typography>
                                <FormatQuoteIcon
                                    sx={{
                                        color: '#1e88e5',
                                        fontSize: '2rem',
                                        mt: 1,
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.85)',
                                        mt: 2,
                                    }}
                                >
                                    {testimonial.text}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
